(()=>{
  document.documentElement.classList.add('la-js');
  const init=(root)=>{
    const els=root.querySelectorAll('.la-reveal:not(.is-in)');
    if(!('IntersectionObserver' in window) || window.Shopify && Shopify.designMode){els.forEach(e=>e.classList.add('is-in'));return;}
    const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}}),{rootMargin:'0px 0px -8% 0px'});
    els.forEach(el=>io.observe(el));
  };
  document.addEventListener('DOMContentLoaded',()=>init(document));
  document.addEventListener('shopify:section:load',e=>init(e.target));

  if(!matchMedia('(prefers-reduced-motion: reduce)').matches){
    let t=false;
    addEventListener('scroll',()=>{if(t)return;t=true;requestAnimationFrame(()=>{
      document.querySelectorAll('.la-hero').forEach(h=>h.style.setProperty('--seal-rot',(-8+Math.min(scrollY,600)*0.03)+'deg'));
      document.querySelectorAll('.la-manifesto__seal').forEach(s=>{const r=s.getBoundingClientRect();const d=Math.max(-10,Math.min(10,(innerHeight/2-r.top-r.height/2)*0.02));s.style.setProperty('--seal-rot2',d+'deg');});
      t=false;})},{passive:true});
  }

  // Quick add (single-variant products). Uses Dawn's cart drawer / notification when present.
  document.addEventListener('submit',async e=>{
    const form=e.target.closest('form.la-quick-add'); if(!form) return;
    e.preventDefault();
    const btn=form.querySelector('button'); btn.disabled=true; btn.classList.add('is-loading');
    const cart=document.querySelector('cart-drawer')||document.querySelector('cart-notification');
    const fd=new FormData(form);
    if(cart && cart.getSectionsToRender){fd.append('sections',cart.getSectionsToRender().map(s=>s.id));fd.append('sections_url',location.pathname);}
    else fd.append('sections','cart-icon-bubble');
    try{
      const res=await fetch((window.routes&&routes.cart_add_url||'/cart/add')+'.js',{method:'POST',headers:{'Accept':'application/javascript','X-Requested-With':'XMLHttpRequest'},body:fd});
      const json=await res.json();
      if(json.status){ btn.textContent=json.description||'Unavailable'; return; }
      document.dispatchEvent(new CustomEvent('cart:add',{detail:{id:fd.get('id'),qty:1}}));
      if(cart && cart.renderContents){ if(cart.classList.contains('is-empty')) cart.classList.remove('is-empty'); cart.renderContents(json); }
      else if(json.sections && json.sections['cart-icon-bubble']){
        const b=document.getElementById('cart-icon-bubble');
        if(b){const d=new DOMParser().parseFromString(json.sections['cart-icon-bubble'],'text/html');const n=d.querySelector('.shopify-section');b.innerHTML=(n||d.body).innerHTML;}
      }
      btn.textContent=btn.dataset.added||'Added';
    }catch(err){ form.submit(); }
    finally{ btn.classList.remove('is-loading'); setTimeout(()=>{btn.disabled=false;},1200); }
  });
})();
